import PropTypes from 'prop-types';
import { ModalGeneric } from 'ypf-pas-general-ui-components';

const NewValueImputationModal = ({ show, onHide, onAccept }) => {
  const handleAccept = () => {
    onAccept();
    onHide();
  };

  return (
    <ModalGeneric
      backdrop
      infoModal
      onHide={onHide}
      primaryAction={handleAccept}
      primaryActionLabel="Aceptar"
      secondaryAction={onHide}
      secondaryActionLabel="Salir"
      show={show}
      title="Nuevo valor de objeto de imputación"
      variantHeader="danger"
    >
      <p className="fw-bold text-center">¿Estas seguro que quieres aplicar un nuevo valor?</p>
      <p className="fw-bold text-center">Se aplicará sobre los anteriores</p>
    </ModalGeneric>
  );
};

export default NewValueImputationModal;

NewValueImputationModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  onAccept: PropTypes.func
};

NewValueImputationModal.defaultProps = {
  show: false,
  onHide: () => {
    /* Empty */
  },
  onAccept: () => {
    /* Empty */
  }
};
